import { ITitleRowLayout } from '../model';

export const TITLE_ICON_TITLE_PRICE_LAYOUT: ITitleRowLayout = {
  visible: true,
  firstColumn: {
    deviceSettings: {
      mobile: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    size: { xs: 1, sm: 1, md: 1, lg: 1 },
  },
  secondColumn: {
    deviceSettings: {
      mobile: {
        visible: true,
        paddingLeft: 0.5,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 1,
        paddingRight: 0,
      },
    },
    size: { xs: 9, sm: 8, md: 8, lg: 8 },
  },
  thirdColumn: {
    deviceSettings: {
      mobile: {
        visible: true,
        paddingLeft: 0.5,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 0.5,
        paddingRight: 0.5,
      },
    },
    size: { xs: 2, sm: 2, md: 2, lg: 2 },
  },
  fourthColumn: {
    deviceSettings: {
      mobile: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    size: { xs: 0, sm: 0, md: 0, lg: 0 },
  },
};

export const TITLE_ICON_TITLE_LAYOUT: ITitleRowLayout = {
  visible: true,
  firstColumn: {
    deviceSettings: {
      mobile: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    size: { xs: 1, sm: 1, md: 1, lg: 1 },
  },
  secondColumn: {
    deviceSettings: {
      mobile: {
        visible: true,
        paddingLeft: 0.5,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 1,
        paddingRight: 0,
      },
    },
    size: { xs: 9, sm: 8, md: 8, lg: 8 },
  },
  thirdColumn: {
    deviceSettings: {
      mobile: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    size: { xs: 0, sm: 0, md: 0, lg: 0 },
  },
  fourthColumn: {
    deviceSettings: {
      mobile: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    size: { xs: 0, sm: 0, md: 0, lg: 0 },
  },
};

export const TITLE_TITLE_PRICE_BUTTON_LAYOUT: ITitleRowLayout = {
  visible: true,
  firstColumn: {
    deviceSettings: {
      mobile: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    size: { xs: 0, sm: 1, md: 1, lg: 1 },
  },
  secondColumn: {
    deviceSettings: {
      mobile: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 1,
        paddingRight: 0,
      },
    },
    size: { xs: 9, sm: 8, md: 8, lg: 8 },
  },
  thirdColumn: {
    deviceSettings: {
      mobile: {
        visible: true,
        paddingLeft: 0.5,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 0.5,
        paddingRight: 0.5,
      },
    },
    size: { xs: 3, sm: 2, md: 2, lg: 2 },
  },
  fourthColumn: {
    deviceSettings: {
      mobile: { visible: true, paddingLeft: 0, paddingRight: 0 },
      desktop: { visible: true, paddingLeft: 0, paddingRight: 0 },
    },
    size: { xs: 1, sm: 1, md: 1, lg: 1 },
  },
};

export const TITLE_TITLE_PRICE_LAYOUT: ITitleRowLayout = {
  visible: true,
  firstColumn: {
    deviceSettings: {
      mobile: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    size: { xs: 0, sm: 1, md: 1, lg: 1 },
  },
  secondColumn: {
    deviceSettings: {
      mobile: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 2.5,
      },
      desktop: {
        visible: true,
        paddingLeft: 1,
        paddingRight: 0,
      },
    },
    size: { xs: 11, sm: 9, md: 9, lg: 9 },
  },
  thirdColumn: {
    deviceSettings: {
      mobile: {
        visible: true,
        paddingLeft: 0.5,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 0.5,
        paddingRight: 0.5,
      },
    },
    size: { xs: 1, sm: 1, md: 1, lg: 1 },
  },
  fourthColumn: {
    deviceSettings: {
      mobile: { visible: false, paddingLeft: 0, paddingRight: 0 },
      desktop: { visible: false, paddingLeft: 0, paddingRight: 0 },
    },
    size: { xs: 0, sm: 0, md: 0, lg: 0 },
  },
};

export const TITLE_TITLE_LAYOUT: ITitleRowLayout = {
  visible: true,
  firstColumn: {
    deviceSettings: {
      mobile: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    size: { xs: 0, sm: 1, md: 1, lg: 1 },
  },
  secondColumn: {
    deviceSettings: {
      mobile: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 1,
        paddingRight: 0,
      },
    },
    size: { xs: 12, sm: 11, md: 11, lg: 11 },
  },
  thirdColumn: {
    deviceSettings: {
      mobile: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    size: { xs: 0, sm: 0, md: 0, lg: 0 },
  },
  fourthColumn: {
    deviceSettings: {
      mobile: { visible: false, paddingLeft: 0, paddingRight: 0 },
      desktop: { visible: false, paddingLeft: 0, paddingRight: 0 },
    },
    size: { xs: 0, sm: 0, md: 0, lg: 0 },
  },
};

export const CUSTOM_TITLE_TITLE_PRICE_LAYOUT: ITitleRowLayout = {
  visible: true,
  firstColumn: {
    deviceSettings: {
      mobile: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    size: { xs: 0, sm: 1, md: 1, lg: 1 },
  },
  secondColumn: {
    deviceSettings: {
      mobile: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 2.5,
      },
      desktop: {
        visible: true,
        paddingLeft: 1,
        paddingRight: 0,
      },
    },
    size: { xs: 11, sm: 9, md: 9, lg: 9 },
  },
  thirdColumn: {
    deviceSettings: {
      mobile: {
        visible: true,
        paddingLeft: 0.5,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 0.5,
        paddingRight: 0.5,
      },
    },
    size: { xs: 1, sm: 2, md: 2, lg: 2 },
  },
  fourthColumn: {
    deviceSettings: {
      mobile: { visible: false, paddingLeft: 0, paddingRight: 0 },
      desktop: { visible: false, paddingLeft: 0, paddingRight: 0 },
    },
    size: { xs: 0, sm: 0, md: 0, lg: 0 },
  },
};
